export const ACCUMULATOR_TYPES = {
  DEDUCTIBLE: 'deductible',
  OOP: 'outOfPocket',
}

export const MEMBER_TYPES = {
  FAMILY: 'family',
}

export const CoverageBenefitsDocuments = {
  SUMMARY_BENEFITS: 'summaryBenefits',
  EXPLANATION_COVERAGE: 'explanationCoverage',
  PLAN_BROCHURE: 'planBrochure',
  PRIOR_AUTH_GUIDELINES: 'priorAuthGuidelines',
  FIND_A_PROVIDER: 'findAProvider',
  FORMULARY_LOOKUP: 'formulary',
  FREE_DRUG_LIST: 'freeDrugList',
  PHARMACY_LOOKUP: 'pharmacyLookup',
  PRICE_TRANSPARENCY: 'priceTransparency',
}

export const CoverageBenefitsHMODocuments = {
  EVIDENCE_OF_COVERAGE: 'evidence_of_coverage',
  EVIDENCE_OF_COVERAGE_AMENDMENT: 'evidence_of_coverage_amendment',
  APPEALS_PROCESS: 'appeals_process',
  DRUG_LIST: 'drug_list',
  DENTAL_RIDER: 'dental_rider',
  VIRTUAL_CARE_RIDER: 'virtual_care_rider',
  PHARMACY_SEARCH: 'pharmacy_search',
  MEDICATION_SEARCH: 'medication_search',
  PLAN_BROCHURE: 'plan_brochure',
  PRIOR_AUTH_GUIDELINES: 'prior_auth_guidelines',
  SUMMARY_BENEFITS: 'summaryBenefits',
  FIND_A_PROVIDER: 'findAProvider',
}

export const BenefitTypeNames = {
  MEDICATION: 'medication',
  PHARMACY: 'pharmacy',
  DENTAL: 'dental',
  VISION: 'vision',
}

export const SSO = 'SSO'
